import { useEffect, useState } from "react";
import { api } from "./api";

let settingsCache = null;

export function useSettings() {
  const [s, setS] = useState(settingsCache);
  useEffect(() => {
    if (!settingsCache) {
      api.get("/settings").then((r) => { settingsCache = r.data; setS(r.data); }).catch(() => {});
    }
  }, []);
  return s;
}

export function useFetch(url, deps = []) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  useEffect(() => {
    let alive = true;
    setState((p) => ({ ...p, loading: true }));
    api.get(url)
      .then((r) => { if (alive) setState({ data: r.data, loading: false, error: null }); })
      .catch((e) => { if (alive) setState({ data: null, loading: false, error: e }); });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, ...deps]);
  return state;
}
